<div class="main-container">
  <app-embedded-loader [show]="showLoader"></app-embedded-loader>

  <app-buyer-supplier-chat
  [headerData]="headerData"
  [isOpen]="isChatOpen"
  [rfqId]="headerData?.rfqId"
  [userId]="userIdAsString"
  [isSupplier]="userRole === 'Suppliers'"
  (close)="closeChat()"
></app-buyer-supplier-chat>


  <div class="title-text">Quotations</div>
  <div class="section" *ngIf="isBuyer">
    <div class="search-filter-container">
      <div class="search-container">
        <mat-icon style="margin-left: 10px">search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchParam"
          placeholder="Search All Documents"
          class="search-input"
        />
        <button class="search-button" (click)="onSearch()">Search</button>
      </div>
      <div class="search-filter-content">
        <mat-form-field class="date-field" appearance="fill">
          <mat-label>From Date</mat-label>
          <input
            matInput
            [matDatepicker]="fromDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="fromDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="fromDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #fromDatepicker></mat-datepicker>

        <mat-form-field class="date-field" appearance="fill">
          <mat-label>To Date</mat-label>
          <input
            matInput
            [matDatepicker]="toDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="toDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="toDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #toDatepicker></mat-datepicker>
        <div class="search-filter-button-container">
          <button type="submit" class="search-btn" (click)="onSearch()">
            <mat-icon>search</mat-icon>
          </button>
          <button type="button" class="close-button" (click)="cancelFilter()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="filter-statuses">
      <button
        *ngFor="let status of filterStatuses; let i = index"
        class="status-btn"
        [ngClass]="{ active: activeIndex === i }"
        (click)="onStatusSelect(status.name, i, status.label)"
        matTooltip="{{ status.label }}"
      >
        {{ status.name }}
      </button>

      <!-- Quote Type Switcher Dropdown -->
      <div class="rfq-type-dropdown" style="margin-left: auto;">
        <button class="status-btn rfq-type-btn" [ngClass]="{ active: true }" (click)="toggleQuoteTypeDropdown()">
          Product Quotation <mat-icon style="font-size: 18px; height: 18px; width: 18px; vertical-align: middle;">arrow_drop_down</mat-icon>
        </button>
        <div class="dropdown-menu rfq-type-menu" *ngIf="quoteTypeDropdownOpen">
          <button class="dropdown-item active-item" (click)="toggleQuoteTypeDropdown()">
            Product Quotation
          </button>
          <button class="dropdown-item" (click)="navigateToQuoteType('service'); toggleQuoteTypeDropdown()">
            Service Quotation
          </button>
        </div>
      </div>
    </div>

    <div
      class="filter-section"
      style="display: flex; align-items: center"
      *ngIf="this.selectedRfq.length > 0"
    >
      <div style="margin-left: 20px">
        <b
          >Selected {{ this.selectedRfq.length }} of
          {{ this.totalRecords }} Quotes</b
        >
      </div>

      <button
        style="position: relative; bottom: 3px"
        mat-icon-button
        mat-sm-button
        color="primary"
        class="mr-1"
        matTooltipClass="mat-tooltip-custom"
        matTooltip="Archive"
        matTooltipPosition="below"
        (click)="rfqOperation('archive')"
      >
        <mat-icon>archive</mat-icon>
      </button>
    </div>

    <div class="dropdown-container-active-table">
      <div class="text-right" style="display: inline-flex; align-items: center">
        <button
          mat-mini-fab
          (click)="exportAllQuotes()"
          matTooltip="Export All"
          matTooltipPosition="below"
        >
          <mat-icon
            matTooltipClass="mat-tooltip-custom"
            svgIcon="downloadExcel"
          ></mat-icon>
        </button>
        <!-- <span style="font-size: 16px;font-weight: bolder;margin-left:5px">Export All</span> -->
      </div>

      <div
        style="
          width: 7%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="invitebutton-container">
          <!-- Button to trigger the user invite menu -->
          <button
            class="circle-button"
            [matMenuTriggerFor]="usermenu"
            matTooltip="Invite User"
            (click)="onUserMenuOpened()"
          >
            <mat-icon class="icon-person"> person_add </mat-icon>
          </button>

          <!-- Menu for inviting users with fixed height and scrollable -->
          <mat-menu #usermenu="matMenu" id="usermenu">
            <!-- Menu content container with scroll event -->
            <div class="menu-content" (scroll)="onScroll()">
              <!-- User list displayed inside the menu with checkboxes for selection -->
              <button
                mat-menu-item
                *ngFor="let item of supplierUsersList"
                (click)="toggleUserSelection(item)"
              >
                <mat-checkbox [checked]="item.selected">{{
                  item.firstName
                }}</mat-checkbox>
              </button>

              <!-- Spinner or loading indicator when fetching more users -->
              <mat-progress-spinner
                *ngIf="isLoading"
                mode="indeterminate"
                diameter="20"
              ></mat-progress-spinner>
            </div>
          </mat-menu>
        </div>
        <div>
          <button
            mat-fab
            class="green-button"
            [matMenuTriggerFor]="menu"
            matTooltip="Show more columns"
          >
            <mat-icon style="position: relative; right: -3px"
              >playlist_add</mat-icon
            >
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of items"
              (click)="toggleSelection(item)"
            >
              <mat-checkbox [checked]="item.selected">{{
                item.label
              }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>

    <div class="active-table-container">
      <ngx-datatable
        style="border-radius: 5px"
        #supplierTable
        class="material expandable bg-light supplier-table sup-tbl"
        [rows]="documentData"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [columnMode]="'force'"
        [limit]="limit"
        [count]="totalRecords"
        [externalPaging]="true"
        [externalSorting]="true"
        [scrollbarH]="false"
        [offset]="offset"
        (page)="onPageChange($event)"
        (sort)="onSort($event)"
        [rowClass]="setRowClass"
      >
        <ngx-datatable-column name="RFQ Reference" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="rfq-reference"
              matTooltip="{{ row.rfqRefNumber }}"
              matTooltipPosition="below"
              (click)="openRfqDetails(row.rfqId)"
              >{{ row.rfqRefNumber }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- Port Name -->
        <ngx-datatable-column name="Vessel" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Port Name"
              matTooltip="{{ row.vesselName }}"
              matTooltipPosition="below"
              >{{ row.vesselName }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- Port Name -->
        <ngx-datatable-column name="Port Name" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Port Name"
              matTooltip="{{ row.portName }}"
              matTooltipPosition="below"
              >{{ row.portName }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- Port Name -->
        <ngx-datatable-column name="Total Supplier" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Total Supplier"
              matTooltip="RFQ Supplier | Quotation Supplier"
              matTooltipPosition="below"
            >
              <span
                style="color: orange"
                [ngClass]="row.disable ? 'readOnlyCell' : ''"
                >{{ row?.rfqSupplierCount }}
              </span>
              |
              <span
                style="color: green"
                [ngClass]="row.disable ? 'readOnlyCell' : ''"
                >{{ row?.supplierQuotationList.length }}
              </span>
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- Status -->
        <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <ng-container *ngIf="row.isAccepted == 1">
              <span
                class="status-pill"
                matTooltip="Accepted"
                matTooltipPosition="below"
                [ngStyle]="{ color: getStatusColor('Accepted') }"
              >
                Accepted
              </span>
            </ng-container>

            <ng-container *ngIf="row.isAccepted == 0">
              <span
                class="status-pill"
                matTooltip="Pending"
                matTooltipPosition="below"
                [ngStyle]="{ color: getStatusColor('Pending') }"
              >
                Pending
              </span>
            </ng-container>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="RFQ Created Date Time span" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="RFQ Date"
              matTooltip="{{ row.rfqDate | date : 'dd/MM/yyyy' }}"
              matTooltipPosition="below"
            >
              {{ formatRfqDate(row.rfqDate) }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
        name="ATT/Print/Download"
        [resizeable]="true"
        [sortable]="false"
        [flexGrow]="0"
        [minWidth]="150"
        [maxWidth]="300"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="action-buttons-container">
            <button
              mat-icon-button
              color="primary"
              matTooltip="Attachments"
              matTooltipPosition="below"
              (click)="togglePreview(true, 'rfq', row)"
            >
              <mat-icon>attach_file</mat-icon>
            </button>
      
      
            <button
              mat-icon-button
              color="primary"
              matTooltip="Print"
              matTooltipPosition="below"
              (click)="downloadRfqForBuyer(row.rfqRefNumber, row)"
            >
              <mat-icon>print</mat-icon>
            </button>
      
            <button
              mat-icon-button
              color="primary"
              matTooltip="Download"
              matTooltipPosition="below"
              (click)="generateRFQExcelForBuyer(row.rfqId)"
            >
              <mat-icon>download</mat-icon>
            </button>
      
            
          </div>
        </ng-template>
      </ngx-datatable-column>

        <ngx-datatable-column
          *ngFor="let column of selectedColumns"
          [name]="column.label"
          [flexGrow]="1"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            
            <!-- Special handling for "Owner" column -->
            <ng-container *ngIf="column.label === 'Owner'; else normalCell">
              <span
                matTooltip="{{ row.buyerUserName ? row.buyerUserName : row.buyerName }}"
                matTooltipPosition="below"
              >
                {{ row.buyerUserName || row.buyerName }}
              </span>
            </ng-container>

            <!-- Default rendering for all other columns -->
            <ng-template #normalCell>
              <span
                *ngIf="isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}
              </span>
              <span
                *ngIf="!isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] || '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] || '-' }}
              </span>
            </ng-template>

          </ng-template>
        </ngx-datatable-column>


        <!-- Toggle Expand Button Column -->
        <ngx-datatable-column
          name="Track Status"
          [sortable]="false"
          [maxWidth]="150"
          [minWidth]="150"
          style="width: auto"
        >
          <ng-template
            let-row="row"
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
          >
            <div style="display: flex; flex-direction: row">
              <button
                mat-icon-button
                matTooltip="View RFQ"
                (click)="toggleExpandRow(row, rowIndex)"
              >
                <mat-icon>{{
                  expandedRowId === row.rfqId ? "expand_less" : "expand_more"
                }}</mat-icon>
              </button>

              <!-- <button
                mat-icon-button
                matTooltip="View RFQ"
                (click)="openRfqDetails(row.rfqId)"
              >
                <mat-icon> visibility </mat-icon>
              </button> -->
            </div>

            <div
              style="width: 1px; height: auto"
              *ngIf="expandedRfqId === row.rfqId"
            ></div>
          </ng-template>
        </ngx-datatable-column>

        <!-- select rfq -->
        <ngx-datatable-column
          [sortable]="false"
          [maxWidth]="55"
          [minWidth]="55"
        >
          <ng-template ngx-datatable-header-template>
            <input
              type="checkbox"
              [checked]="this.selectedRfq.length == this.documentData.length"
              (change)="toggleSelectAll($event, 'active')"
            />
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <!-- <input type="checkbox" [checked]="isChecked(row.rfqId,'active')"
                                  (change)="selectDeselectRfq($event, row.rfqId,'active',row.owner)" /> -->
            <input
              type="checkbox"
              [checked]="isChecked(row.quoteId, 'active')"
              (change)="
                selectDeselectRfq(
                  $event,
                  row.supplierRfqDetailsId,
                  row.quoteId,
                  'active',
                  row.buyerUserName
                )
              "
            />
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-row-detail [rowHeight]="getRowHeight" #myDetailRow>
          <ng-template
            let-row="row"
            let-expanded="expanded"
            ngx-datatable-row-detail-template
          >
            <div
              class="status-tracker-main-container"
              *ngIf="expandedRowId === row.rfqId"
            >
              <div class="expanded-status-row">
                <div class="status-timeline-container">
                  <!-- <div class="timeline-box-header">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages"
                    >
                      <div class="timeline-stage-header">
                        <div class="stage-header-up">
                          <span class="stage-heading">{{ stage.heading }}</span>
                          <span class="stage-date">{{ stage.date }}</span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div class="timeline-box">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages"
                    >
                      <div class="timeline-stage">
                        <div class="stage-header">
                          <span class="stage-label">{{ stage.label }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-box-footer">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages; let i = index"
                    >
                      <div class="timeline-stage-footer">
                        <div
                          class="stage-point"
                          [ngClass]="[
                            getStageColorClass(stage.label, row),
                            'animate-point',
                            getCompleteIncompleteClass(stage)
                          ]"
                          [style.animationDelay]="i * 1.2 + 's'"
                        ></div>
                        <div
                          *ngIf="i < row.statusesStages.length - 1"
                          class="timeline-line animate-line"
                          [ngClass]="[
                            getStageColorClass(stage.label, row),
                            getCompleteIncompleteClass(stage)
                          ]"
                          [style.animationDelay]="i * 1.2 + 0.6 + 's'"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-box-header">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages"
                    >
                      <div class="timeline-stage-header">
                        <div class="stage-header-up">
                          <!-- <span class="stage-heading">{{ stage.heading }}</span> -->
                          <span class="stage-date">{{ stage.date }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Implement here the table -->
                  <!-- RFQ Supplier Table -->
                  <!-- Top-right action buttons -->
                  <div
                    style="
                      padding-left: 8px;
                      padding-right: 8px;
                      margin-top: 20px;
                      overflow-x: auto;
                      overflow-y: auto;
                      max-height: 242px;
                      
                    "
                  >
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th>Quotation Ref No</th>
                          <th>Supplier Name</th>
                          <th>Items Quoted</th>
                          <th>
                            Requested Total Cost (Buyers Currency)
                            <mat-slide-toggle
                              (change)="toggleWrapDescription($event, row,'quote')"
                              [checked]="showQuoteReqCost"
                              class="ml-2"
                            >
                            </mat-slide-toggle>
                          </th>
                          <th *ngIf="showQuoteReqCost">
                            Total Quoted Price (Supplier Currency)
                          </th>
                          <th>Rating</th>
                          <th>Payment Terms</th>
                          <th>Incoterm</th>
                          <th>Incoterm Location</th>
                          <th>Quality</th>
                          <!-- <th>Status</th> -->
                          <th>Action</th>
                          <th>Ask Any Question</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let supplier of row.supplierQuotationList">
                          <td>{{ supplier.quoteRefNumber || "N/A" }}</td>
                          <td
                            style="color: #007bff; cursor: pointer"
                            (click)="
                              fetchQuoteLineItemDetailsByQuoteId(
                                supplier.quoteId
                              )
                            "
                          >
                            {{ supplier.supplierName || "N/A" }}
                          </td>
                          <td>{{ supplier.itemQuoted || 0 }}</td>
                          <td>{{ row.rfqReqCurrencyCode }} {{
                            getConvertedAmount(
                              supplier,
                              row.rfqReqCurrencyCode
                            )
                          }}</td>
                          <td *ngIf="showQuoteReqCost">
                           
                              {{supplier.quoteCurrency}} {{ supplier.totalCost || "N/A" }}
                           
                          </td>
                          <td>
                            <div class="star-container">
                              <span class="fa fa-star checked"></span>
                              <span class="fa fa-star checked"></span>
                              <span class="fa fa-star checked"></span>
                              <span class="fa fa-star"></span>
                              <span class="fa fa-star"></span>
                            </div>
                          </td>
                          <td>{{ supplier.paymentTermsName || "N/A" }}</td>
                          <td>{{ supplier.incotermsName || "N/A" }}</td>
                          <td>{{ supplier.incotermLocations || "N/A" }}</td>
                          <td>{{ supplier.offeredQualityName || "N/A" }}</td>
                          <!-- <td>{{ supplier.buyerQuoteStatus || "N/A" }}</td> -->

                          <!-- Action buttons (like view/edit/compare) -->
                          <td>
                            <button
                              mat-icon-button
                              color="primary"
                              (click)="
                                viewQuotePreview(
                                  supplier.quoteId,
                                  supplier.supplierId,
                                  supplier.rfqId
                                )
                              "
                            >
                              <mat-icon>visibility</mat-icon>
                            </button>

                            <button
                              
                              mat-icon-button
                              color="primary"
                              matTooltip="Attachments"
                              matTooltipPosition="below"
                              (click)="togglePreview(true,'quote', supplier)"
                            >
                              <mat-icon>attach_file</mat-icon>
                            </button>
                      
                            <button
                            
                              mat-icon-button
                              color="primary"
                              matTooltip="Supplier contact Details"
                              matTooltipPosition="below"
                              (click)="toggleContactPopUp(true, supplier)"
                            >
                              <mat-icon>local_phone</mat-icon>
                            </button>
                      
                            <button
                            
                              mat-icon-button
                              color="primary"
                              matTooltip="Print"
                              matTooltipPosition="below"
                              (click)="downloadQuote(row, supplier)"
                            >
                              <mat-icon>print</mat-icon>
                            </button>
                      
                            <button
                             
                              mat-icon-button
                              color="primary"
                              matTooltip="Download"
                              matTooltipPosition="below"
                              (click)="generateQuoteExcel(supplier.quoteId, supplier.rfqId, supplier.supplierId, supplier.quoteRefNumber)"
                            >
                              <mat-icon>download</mat-icon>
                            </button>

                          </td>

                          <!-- Ask question button -->
                          <td>
                            <button
                              mat-icon-button
                              matBadge="{{ supplier.questions }}"
                              matBadgeColor="primary"
                              (click)="openChat(row, supplier)"
                            >
                              <mat-icon>chat</mat-icon>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-row-detail>
      </ngx-datatable>
    </div>

    <div class="archive-container" #heading>
      <span
        style="
          padding-left: 16px;
          padding-top: 16px;
          margin-bottom: 20px;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          padding-right: 20px;
        "
        (click)="toggleArchived()"
      >
        <div style="display: inline-flex; align-items: center">
          <span style="margin-left: 4px">Archived Documents</span>
        </div>

        <mat-icon>
          {{ isArchivedExpand ? "expand_less" : "expand_more" }}
        </mat-icon>
      </span>

      <ng-container *ngIf="isArchivedExpand">
        <div
          class="filter-section-selection-container"
          style="display: flex; align-items: center"
          *ngIf="this.selectedArchivedRfq.length > 0"
        >
          <div style="margin-left: 10px">
            <b
              >Selected {{ this.selectedArchivedRfq.length }} of
              {{ this.archivedTotalRecords }} archived Quotes</b
            >
          </div>

          <button
            style="position: relative; bottom: 3px"
            mat-icon-button
            mat-sm-button
            color="primary"
            class="mr-1"
            matTooltipClass="mat-tooltip-custom"
            matTooltip="Urchive"
            matTooltipPosition="below"
            (click)="rfqOperation('unarchive')"
          >
            <mat-icon>unarchive</mat-icon>
          </button>
        </div>
        <div class="dropdown-container">
          <button
            mat-fab
            class="green-button"
            [matMenuTriggerFor]="menu"
            matTooltip="Show more columns"
          >
            <mat-icon style="position: relative; right: -3px"
              >playlist_add</mat-icon
            >
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of archivedItems"
              (click)="archivedToggleSelection(item)"
            >
              <mat-checkbox [checked]="item.selected">{{
                item.label
              }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>
        <ngx-datatable
          #archivedSection
          #supplierTable
          class="material expandable bg-light supplier-table sup-tbl"
          [rows]="archivedDocumentData"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [columnMode]="'force'"
          [limit]="limit"
          [count]="archivedTotalRecords"
          [externalPaging]="true"
          [externalSorting]="true"
          [scrollbarH]="false"
          [offset]="archivedOffset"
          (page)="onArchivedPageChange($event)"
          (sort)="onSort($event)"
          [rowClass]="setRowClass"
        >
          <ngx-datatable-column name="RFQ Reference" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="rfq-reference"
                matTooltip="{{ row.rfqRefNumber }}"
                matTooltipPosition="below"
                (click)="openRfqDetails(row.rfqDetailsId)"
                >{{ row.rfqRefNumber }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <!-- Port Name -->
          <ngx-datatable-column name="Vessel" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Port Name"
                matTooltip="{{ row.vesselName }}"
                matTooltipPosition="below"
                >{{ row.vesselName }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <!-- Port Name -->
          <ngx-datatable-column name="Port Name" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Port Name"
                matTooltip="{{ row.portName }}"
                matTooltipPosition="below"
                >{{ row.portName }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <!-- Port Name -->
          <ngx-datatable-column name="Total Supplier" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Total Supplier"
                matTooltip="RFQ Supplier | Quotation Supplier"
                matTooltipPosition="below"
              >
                <span
                  style="color: orange"
                  [ngClass]="row.disable ? 'readOnlyCell' : ''"
                  >{{ row?.rfqSupplierCount }}
                </span>
                |
                <span
                  style="color: green"
                  [ngClass]="row.disable ? 'readOnlyCell' : ''"
                  >{{ row?.supplierQuotationList.length }}
                </span>
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Status -->
          <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <!-- <span class="status-pill" matTooltip="{{ quoteStatuses[row.quoteStatus - 1] }}"
                    matTooltipPosition="below" [ngStyle]="{
                      color: getStatusColor(quoteStatuses[row.quoteStatus - 1])
                    }">
                    {{ quoteStatuses[row.quoteStatus - 1] }}
                </span> -->
              <ng-container *ngIf="row.isAccepted == 1">
                <span
                  class="status-pill"
                  matTooltip="Accepted"
                  matTooltipPosition="below"
                  [ngStyle]="{ color: getStatusColor('Accepted') }"
                >
                  Accepted
                </span>
              </ng-container>

              <ng-container *ngIf="row.isAccepted == 0">
                <span
                  class="status-pill"
                  matTooltip="Pending"
                  matTooltipPosition="below"
                  [ngStyle]="{ color: getStatusColor('Pending') }"
                >
                  Pending
                </span>
              </ng-container>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="RFQ Created Date Time span" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="RFQ Date"
                matTooltip="{{ row.rfqDate | date : 'dd/MM/yyyy' }}"
                matTooltipPosition="below"
              >
                {{ formatRfqDate(row.rfqDate) }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            *ngFor="let column of archivedSelectedColumns"
            [name]="column.label"
            [flexGrow]="1"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>

              <!-- Special handling for "Owner" column -->
              <ng-container *ngIf="column.label === 'Owner'; else archivedNormalCell">
                <span
                  matTooltip="{{ row.buyerUserName ? row.buyerUserName : row.buyerName }}"
                  matTooltipPosition="below"
                >
                  {{ row.buyerUserName || row.buyerName }}
                </span>
              </ng-container>

              <!-- Default rendering for all other columns -->
              <ng-template #archivedNormalCell>
                <span
                  *ngIf="isDate(row[column.prop])"
                  matTooltip="{{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}"
                  matTooltipPosition="below"
                >
                  {{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}
                </span>
                <span
                  *ngIf="!isDate(row[column.prop])"
                  matTooltip="{{ row[column.prop] || '-' }}"
                  matTooltipPosition="below"
                >
                  {{ row[column.prop] || '-' }}
                </span>
              </ng-template>

            </ng-template>
          </ngx-datatable-column>


          <ngx-datatable-column
            name="Action"
            [flexGrow]="1"
            [resizeable]="true"
          >
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="bold-header">Action</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <button
                [mdePopoverTriggerFor]="appPopover"
                mdePopoverTriggerOn="click"
                [mdePopoverBackdropCloseOnClick]="false"
                mat-icon-button
                matTooltip="Restore Quote"
                #popoverTrigger="mdePopoverTrigger"
              >
                <mat-icon style="color: #f99c30"> restore </mat-icon>
              </button>
              <mde-popover
                #appPopover="mdePopover"
                [mdePopoverOverlapTrigger]="false"
              >
                <mat-card class="mat-card-popover">
                  <mat-card-header class="mat-card-header-popover">
                    <mat-card-title>Are you sure?</mat-card-title>
                  </mat-card-header>

                  <mat-card-actions
                    class="mat-card-action-popover display-flex justify-content-space-between"
                    style="gap: 10px"
                  >
                    <button
                      class="mat-action-btn popover_action cancel"
                      mat-raised-button
                    >
                      Cancel
                    </button>
                    <button
                      class="mat-action-btn popover_action"
                      (click)="restore(row.quoteId, 'unArchive')"
                      mat-raised-button
                      color="warn"
                    >
                      Restore
                    </button>
                  </mat-card-actions>
                </mat-card>
              </mde-popover>
            </ng-template>
          </ngx-datatable-column>

          <!-- select rfq -->
          <ngx-datatable-column
            [sortable]="false"
            [maxWidth]="55"
            [minWidth]="55"
          >
            <ng-template ngx-datatable-header-template>
              <input
                type="checkbox"
                [checked]="this.selectedRfq.length == this.documentData.length"
                (change)="toggleSelectAll($event, 'inactive')"
              />
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <!-- <input type="checkbox" [checked]="isChecked(row.rfqId,'active')"
                          (change)="selectDeselectRfq($event, row.rfqId,'active',row.owner)" /> -->
              <input
                type="checkbox"
                [checked]="isChecked(row.quoteId, 'inactive')"
                (change)="
                  selectDeselectRfq(
                    $event,
                    row.supplierRfqDetailsId,
                    row.quoteId,
                    'inactive',
                    row.supplierUserName
                  )
                "
              />
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ng-container>
    </div>
  </div>
</div>

<div class="sidebar" style="overflow: auto" *ngIf="showProductPopUp">
  <div
    class="sidebar-title"
    style="justify-content: space-between; padding: 15px 15px"
  >
    <div class="sidebar-title-text">Detail View</div>
    <div style="display: flex; justify-content: right; width: 50%; gap: 10px">
      <span
        style="float: right"
        class="pointer header-close-btn"
        matTooltipClass="mat-tooltip-custom"
        matTooltip="Close"
        matTooltipPosition="below"
        (click)="toggleSidebar(false)"
      >
        <mat-icon style="color: white">close</mat-icon>
      </span>
    </div>
  </div>

  <div class="sidebar-content">
    <app-embedded-loader [show]="showDetailLoader"></app-embedded-loader>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>Part No</th>
          <th>Product</th>
          <th>
            Requested Price
            <mat-slide-toggle
              (change)="toggleShowColumn('productCost')"
              [checked]="showProductReqCost"
              class="ml-2"
            >
            </mat-slide-toggle>
          </th>
          <th *ngIf="showProductReqCost">Quoted Price</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of quoteLineItemData">
          <td>{{ item.partNo || "N/A" }}</td>
          <td>{{ item.description || "N/A" }}</td>
          <td>{{ item.buyerCurrencyCode }} {{ item.totalCost || 0 }}</td>
          <td *ngIf="showProductReqCost">
            {{ item.supplierCurrencyCode }} {{ item.totalCost || 0 }}
          </td>
        </tr>
      </tbody>
    </table>

    <div class="button-container">
      <button type="button" class="close-button" (click)="toggleSidebar(false)">
        <mat-icon>cancel</mat-icon>
      </button>
    </div>
  </div>
</div>


<app-document-preview
  [previewDocs]="previewDocs"
  [showPopup]="previewSection"
  (close)="previewSection = false">
</app-document-preview>

<app-contact-details
  [showContactPopup]="showContactPopup"
  [contactData]="selectedSupplier"
  (close)="showContactPopup = false">
</app-contact-details>
